import cx from "classnames";
import React from "react";

import { Viewer } from "@/mk2/apps/bazaar/constants";
import { planGetPlusUrl } from "@/mk2/apps/plan/urls";
import { Link } from "@/mk2/components/Link";
import { PlusBadge } from "@/mk2/components/PlusBadge";
import { url } from "@/mk2/helpers/urls";
import { BUYER_HAS_SEEN_AD, SELLER_HAS_SEEN_AD } from "@/mk/autogenerated/translation";

import styles from "./HasSeenAd.mscss";

interface OwnProps {
    className?: string;
    viewer: Viewer;
}

type Props = OwnProps;

const HasSeenAd: React.FunctionComponent<Props> = ({ className, viewer }) => (
    <div className={cx(styles.HasSeenAd, className)}>
        <Link to={url(planGetPlusUrl, {}, { src: "message-seller" })}>
            <PlusBadge /> {viewer === Viewer.BUYER ? BUYER_HAS_SEEN_AD : SELLER_HAS_SEEN_AD}
        </Link>
    </div>
);

HasSeenAd.displayName = "HasSeenAd";

export default React.memo<Props>(HasSeenAd);
